import { render, staticRenderFns } from "./ModalAgregarGrupo.vue?vue&type=template&id=1adde4dc"
import script from "./ModalAgregarGrupo.vue?vue&type=script&lang=js"
export * from "./ModalAgregarGrupo.vue?vue&type=script&lang=js"
import style0 from "./ModalAgregarGrupo.vue?vue&type=style&index=0&id=1adde4dc&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports